<template>
    <div class="promo-card">
        <div class="promo-card__text">
            <p class="promo-card__title">
                {{ blok.Title?.length > 65 ? blok.Title.slice(0, 65) + '…' : blok.Title }}
            </p>

            <NuxtLink
                v-if="blok.ButtonText"
                class="promo-card__bottom"
                :to="getInternalLink(blok.Link)"
                :target="blok.Link.target"
                external
            >
                <span>
                    {{ blok.ButtonText?.length > 20 ? blok.ButtonText.slice(0, 20) + '…' : blok.ButtonText }}
                </span>
                <NuxtIcon name="ri:arrow-right-s-line" class="promo-card__icon" />
            </NuxtLink>
        </div>
        <NuxtImg
            v-if="blok.Image?.filename"
            :src="blok.Image.filename"
            :alt="blok.Image.alt || ''"
            provider="storyblok"
            format="webp"
            loading="lazy"
            sizes="150px"
            densities="x1 x2"
            quality="50"
            class="promo-card__image"
        />
    </div>
</template>

<script setup lang="ts">
import type { ILinkCard } from '~ui/types/components/LinkCard';

defineProps<{ blok: ILinkCard }>();
</script>

<style scoped lang="postcss">
.promo-card {
    @apply w-full min-h-[100px] flex justify-between items-stretch rounded-lg
    border border-wl-base-borders bg-white overflow-hidden;
    box-shadow: 0px 8px 16px 0px #2b2e310a;
}

.promo-card__text {
    @apply flex flex-col justify-between flex-1 pl-4 pr-2 py-3;
}

.promo-card__title {
    @apply text-sm leading-5 font-semibold text-brand-dark-gray;
}

.promo-card__bottom {
    @apply flex items-center justify-between w-full text-[13px] font-normal leading-5 text-primary hover:underline;
}

.promo-card__icon {
    @apply text-base text-primary w-4 h-4;
}

.promo-card__image {
    @apply w-[150px] max-h-[100px] self-stretch object-cover;
}
</style>
